import React from "react";

const popularCars = [
  {
    name: "Dzire",
    image: "/images/ourfleets/1.jpg",
    rating: 5.0,
    description:
      "The Maruti Suzuki Dzire is a compact sedan perfect for city commutes and intercity travel. With seating for 4 passengers and excellent mileage (up to 25 km/l), it’s an affordable and comfortable choice for daily cab services.",
    localRate: "8Hrs/80KM : Rs.2000/-",
    extraKM: "Rs.12/-",
    extraHR: "Rs.150/-",
  },
  {
    name: "Etios",
    image: "/images/ourfleets/ETIOS.jpg",
    rating: 4.9,
    description:
      "Toyota Etios offers a smooth and spacious ride, ideal for long-distance journeys and airport transfers. Known for reliability and ample luggage space, it remains a popular choice in the taxi segment.",
    localRate: "8Hrs/80KM : Rs.2000/-",
    extraKM: "Rs.12/-",
    extraHR: "Rs.150/-",
  },
  {
    name: "Xcent",
    image: "/images/ourfleets/XCENT.jpg",
    rating: 4.7,
    description:
      "Hyundai Xcent is a compact, fuel-efficient sedan suited for local rides and airport pickups. With comfortable interiors and good mileage, it’s a smart option for short-distance travel.",
    localRate: "8Hrs/80KM : Rs.2000/-",
    extraKM: "Rs.12/-",
    extraHR: "Rs.150/-",
  },
  {
    name: "Ertiga",
    image: "/images/ourfleets/4.jpg",
    rating: 4.8,
    description:
      "The Maruti Suzuki Ertiga is a 7-seater MUV, perfect for family trips, group travel, and outstation tours. With flexible luggage space and CNG options, it delivers great comfort and economy for longer journeys.",
    localRate: "8Hrs/80KM : Rs.2500/-",
    extraKM: "Rs.14/-",
    extraHR: "Rs.200/-",
  },
  {
    name: "Innova",
    image: "/images/ourfleets/7.jpg",
    rating: 4.5,
    description:
      "Toyota Innova is India’s most trusted MUV for comfortable and spacious travel. Ideal for outstation rides and tourist trips, it offers excellent seating, ample luggage space, and a smooth ride across long distances.",
    localRate: "8Hrs/80KM : Rs.2700/-",
    extraKM: "Rs.17/-",
    extraHR: "Rs.200/-",
  },
  {
    name: "Innova Crysta",
    image: "/images/ourfleets/5.jpg",
    rating: 4.8,
    description:
      "The Innova Crysta adds a premium touch to group travel with luxurious interiors, advanced features, and powerful performance. It’s the top choice for executive rides, business travel, and family tours in absolute comfort.",
    localRate: "8Hrs/80KM : Rs.3300/-",
    extraKM: "Rs.19/-",
    extraHR: "Rs.250/-",
  },
];

const Booking = () => {
  const whatsappNumber = "918390907004"; // without + symbol

  // Function to open WhatsApp with pre-filled message
  const handleBookNow = (carName) => {
    const message = `Hello, I would like to book the ${carName} cab. Please share the details.`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Booking</h1>
          </div>
        </div>
      </section>

      <section className="popular-car-section pt_120 pb_90 grey-bg">
        <div className="container">
          <div className="row">
            {popularCars.map((car, index) => (
              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={index}>
                <div className="single-popular-car-block">
                  <div className="single-popular-car-image">
                    <img src={car.image} alt={car.name} />
                  </div>

                  <div className="single-popular-car-content">
                    <div className="single-popular-car-rating">
                      <i className="fa-solid fa-star text-warning"></i> {car.rating}
                    </div>
                    <h5 className="single-popular-car-title">{car.name}</h5>
                    <p className="single-popular-car-text">{car.description}</p>

                    <div className="border-divider"></div>

                    <ul className="single-popular-car-info">
                      <li>
                        <i className="fa-solid fa-car-side me-2 text-primary"></i>
                        Local {car.localRate}
                      </li>
                      <li>
                        <i className="fa-solid fa-road me-2 text-primary"></i>
                        Extra KM: {car.extraKM}
                      </li>
                      <li>
                        <i className="fa-solid fa-clock me-2 text-primary"></i>
                        Extra HR: {car.extraHR}
                      </li>
                    </ul>

                    <div className="single-popular-car-book-btn text-center">
                      <button
                        className="btn-style-three"
                        onClick={() => handleBookNow(car.name)}
                      >
                        <i className="fa-brands fa-whatsapp me-2 "></i> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
